import dayjs from '../dayjs';

import { deleteClientData, getClientData, setClientData } from '../clientData';

export const CONSENT_KEY = 'vansite.consent';
export const LEGACY_CONSENT_KEY = 'vansite.cookiesAccepted';
export const CONSENT_VERSION = 2;
const CONSENT_TTL_MONTHS = 12;

const listeners = new Set();

const cookieOptions = () => ({
  sameSite: 'Lax',
  secure: typeof window !== 'undefined' && window.location.protocol === 'https:',
});

/**
 * @returns {{version: number, ts: string, statistics: boolean, marketing: boolean} | null}
 */
export const getConsent = () => {
  if (typeof window === 'undefined') return null;
  // The v1 binary flag has no category granularity — drop it so the user is re-prompted once.
  if (getClientData(LEGACY_CONSENT_KEY) !== null) deleteClientData(LEGACY_CONSENT_KEY);
  const stored = getClientData(CONSENT_KEY);
  if (!stored || stored.version !== CONSENT_VERSION) return null;
  return stored;
};

/**
 * @param {{statistics: boolean, marketing: boolean}} categories
 */
export const setConsent = ({ statistics, marketing }) => {
  if (typeof window === 'undefined') return null;
  const consent = {
    version: CONSENT_VERSION,
    ts: new Date().toISOString(),
    statistics: !!statistics,
    marketing: !!marketing,
  };
  setClientData(CONSENT_KEY, consent, dayjs().add(CONSENT_TTL_MONTHS, 'months'), cookieOptions());
  listeners.forEach((cb) => {
    try {
      cb(consent);
    } catch (e) {
      // one broken listener must not break the others
    }
  });
  return consent;
};

/**
 * @param {'statistics' | 'marketing'} category
 */
export const hasConsent = (category) => {
  const consent = getConsent();
  return !!(consent && consent[category]);
};

/**
 * @param {(consent: object) => void} cb
 * @returns {() => void} unsubscribe
 */
export const onConsentChange = (cb) => {
  listeners.add(cb);
  return () => listeners.delete(cb);
};
